/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * DSV Public API
 * DSV Public API
 * OpenAPI spec version: 1.5.2
 */

export type EventRegistrationFormStatus = typeof EventRegistrationFormStatus[keyof typeof EventRegistrationFormStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventRegistrationFormStatus = {
  WAIT: 'WAIT',
  OPEN: 'OPEN',
  PRIVATE: 'PRIVATE',
  WAITING_LIST: 'WAITING_LIST',
  FULL: 'FULL',
  CLOSED: 'CLOSED',
} as const;
